import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=b7fd2a0c&scoped=true&"
import script from "./FirstPage.vue?vue&type=script&lang=js&"
export * from "./FirstPage.vue?vue&type=script&lang=js&"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=b7fd2a0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fd2a0c",
  null
  
)

export default component.exports